import JobTabs from "../_JobsTabs";
import AppLayout from "@/layouts/AppLayout";
import { JobsHeader } from "../_components/JobsHeader";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";

export default function JobPage() {
  useRequireCapability({ domain: DOMAIN.JOBS, permission: PERMISSION.viewJobPosts });

  return (
    <AppLayout>
      <div data-testid="jobs-page">
        <JobsHeader title="Jobs" />
        <div>
          <JobTabs />
        </div>
      </div>
    </AppLayout>
  );
}
